import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  acquisitors: null,
  inquirers: null,
  managers: null,
  submission: null,
  qualityTeam: null,
  contentBuyers: null,
  companies: null,
  adminSidbarOpen: false,
  qcSidbarOpen: false,
  qcSubmisson: null,
  scrollSuperNav: 0,
  stopScroll: false,
};

const appStateSlice = createSlice({
  name: "appStateSlice",
  initialState,
  reducers: {
    setAcquisitors: (state, action) => {
      state.acquisitors = action.payload;
    },
    setInquirers: (state, action) => {
      state.inquirers = action.payload;
    },
    setManagers: (state, action) => {
      state.managers = action.payload;
    },
    setSubmission: (state, action) => {
      state.submission = action.payload;
    },
    setQualityTeam: (state, action) => {
      state.qualityTeam = action.payload;
    },
    setContentBuyers: (state, action) => {
      state.contentBuyers = action.payload;
    },
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
    setAdminSidebarOpen: (state, action) => {
      state.adminSidbarOpen = action.payload;
    },
    setQcSidebarOpen: (state, action) => {
      state.qcSidbarOpen = action.payload;
    },
    setQcSubmission: (state, action) => {
      state.qcSubmisson = action.payload;
    },
    setScrollSuperNav: (state, action) => {
      state.scrollSuperNav = action.payload;
    },
    setStopScroll: (state, action) => {
      state.stopScroll = action.payload;
    },
  },
});

export const {
  setAcquisitors,
  setInquirers,
  setManagers,
  setSubmission,
  setQualityTeam,
  setContentBuyers,
  setCompanies,
  setAdminSidebarOpen,
  setQcSidebarOpen,
  setQcSubmission,
  setScrollSuperNav,
  setStopScroll,
} = appStateSlice.actions;

export default appStateSlice.reducer;
